import { render, staticRenderFns } from "./Landpage.vue?vue&type=template&id=73e4e485&"
import script from "./Landpage.vue?vue&type=script&lang=js&"
export * from "./Landpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports